import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import type { ApiDrop } from "@/generated/models/ApiDrop";
export function getIsDirectMessage(wave: {
  id: string;
}, fallback = false): boolean {
  const w = wave as {
    is_direct_message?: boolean | undefined;
    chat?: {
      scope?: {
        group?: {
          is_direct_message?: boolean | undefined;
        } | undefined;
      } | undefined;
    } | undefined;
  };
  return w.chat?.scope?.group?.is_direct_message ?? w.is_direct_message ?? fallback;
}
export function useWaveNavigation() {
  const $ = _c(11);
  const router = useRouter();
  const {
    isApp
  } = useDeviceInfo();
  let t0;
  if ($[0] !== isApp || $[1] !== router) {
    t0 = (waveId, serialNo, isDirectMessage) => {
      router.push(getWaveRoute({
        waveId,
        serialNo,
        isDirectMessage,
        isApp
      }));
    };
    $[0] = isApp;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const navigateToWave = t0;
  let t1;
  if ($[3] !== navigateToWave) {
    t1 = (waveId_0, isDirectMessage_0) => serialNo_0 => {
      navigateToWave(waveId_0, serialNo_0, isDirectMessage_0);
    };
    $[3] = navigateToWave;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const createReplyClickHandler = t1;
  let t2;
  if ($[5] !== navigateToWave) {
    t2 = t3 => {
      const fallbackIsDm = t3 === undefined ? false : t3;
      return quote => {
        const quoteIsDm = getIsDirectMessage(quote.wave, fallbackIsDm);
        navigateToWave(quote.wave.id, quote.serial_no, quoteIsDm);
      };
    };
    $[5] = navigateToWave;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const createQuoteClickHandler = t2;
  let t3;
  if ($[7] !== createQuoteClickHandler || $[8] !== createReplyClickHandler || $[9] !== navigateToWave) {
    t3 = {
      navigateToWave,
      createReplyClickHandler,
      createQuoteClickHandler
    };
    $[7] = createQuoteClickHandler;
    $[8] = createReplyClickHandler;
    $[9] = navigateToWave;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}